import { youTubeEmbed } from './imports/youTubeEmbed.js';

youTubeEmbed();